import { useDispatch, useSelector } from 'react-redux';

// Design System
import { Message } from 'jl-design-system/components/message/Message';

// Types
import { AppDispatch } from 'types/RootState.types';
import { CollectionDatesUnavailableProps } from './CollectionDatesUnavailable.types';

// Config
import collectionDatesUnavailableState from './CollectionDatesUnavailable.state';
import {
  selectCollectionPoint,
  changeClickAndCollectSelectedPoint,
} from '@redux/actions/click-and-collect/clickAndCollectActions';

const getTitleText = (isCollectPlus: boolean) => {
  if (isCollectPlus) {
    return "Sorry, we're having technical difficulties";
  }

  return "Sorry, we're having trouble finding available days for collection";
};

const CollectionDatesUnavailable = ({ collectionPointDatesEmpty = false }: CollectionDatesUnavailableProps) => {
  const dispatch: AppDispatch = useDispatch();
  const { collectionPoint, isCollectPlus } = useSelector(collectionDatesUnavailableState);

  const changeClickAndCollectSelectedPointHandler = () => dispatch(changeClickAndCollectSelectedPoint());
  const selectCollectionPointHandler = () =>
    dispatch(
      selectCollectionPoint({
        collectionPoint,
      }),
    );

  if (collectionPointDatesEmpty) {
    const emptyMessageProps = {
      body: 'Please try a different shop. If the problem persists please try again later or choose to have your order delivered instead.',
      buttonProps: {
        onClick: changeClickAndCollectSelectedPointHandler,
      },
      buttonText: 'Change shop',
    };

    return <Message {...emptyMessageProps} title={getTitleText(isCollectPlus)} type="error" />;
  }

  const messageProps = {
    body: 'Please try again. If the problem persists please try again later or choose to have your order delivered instead.',
    buttonProps: {
      onClick: selectCollectionPointHandler,
    },
    buttonText: isCollectPlus ? 'Try again' : 'Find available collection days',
  };

  return <Message {...messageProps} title={getTitleText(isCollectPlus)} type="error" />;
};

export default CollectionDatesUnavailable;
